// extracted by mini-css-extract-plugin
export default {"content":"Product_dev3_content__qSFep","ref":"Product_dev3_ref__4gyv-"};